export enum BlackjackActionName {
    DEAL = "DEAL",
    DOUBLE = "DOUBLE",
    HIT = "HIT",
    STAND = "STAND",
    SPLIT = "SPLIT",
    INSURE = "INSURE",
}



// WEBPACK FOOTER //
// ./src/app/api/BlackjackActionName.ts